import React, { useEffect, useState } from "react";
import { useApp } from "../../contexts/index";
import { getCookie, setCookie } from "../../utils/helper";
import { Form, Input, Tabs } from "antd";
import {
  getProfile,
  getSettingInstagram,
  handleSignupStep1,
  postAppleAuth,
  postAppleAuth2,
  postAppleAuth3,
  postCheckIsExistEmail,
  postFacebookAuth,
  postFacebookAuth2,
  postFacebookAuth3,
  postGoogleAuth2,
  postGoogleAuth3,
  postInstagramAuth2,
  postInstagramAuth3,
  postLoginPassword,
  postSentOTP,
} from "../../services/app";
import { useNavigate, useSearchParams } from "react-router-dom";
import useStateAsync from "use-state-async";
import { useGoogleLogin } from "@react-oauth/google";
import useLoginInstagram from "../../hook/useLoginInstagram";
import environment from "../../environment";
import { ssoLoginUrl } from "../../utils/helper";

function Auth(props) {
  const { T, setUser, user, setAlert, loading, setLoading, isTabLogin } =
    useApp();
  const [searchParams] = useSearchParams();
  const [mode, setMode] = useState("password");
  const [sentOtp, setSentOtp] = useState(0);
  const [emailVerify, setEmailVerify] = useState();
  const [formValues, setFormValues] = useState({});
  const [modalCreateAccount, setModalCreateAccount] = useStateAsync({});
  const [modalVerifyEmail, setModalVerifyEmail] = useStateAsync({});
  const [modalConfirmRequestSignup, setModalConfirmRequestSignup] =
    useStateAsync({});
  const userRef = React.useRef();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isEnableInstagram, setIsEnableInstagram] = useState(false);

  useEffect(() => {
    getSettingInstagram()
      .then(({ data }) => {
        setIsEnableInstagram(data?.data?.value === "true");
      })
      .catch(() => {});
    userRef.current = {};
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setSentOtp((prevState) => {
        if (prevState > 0) {
          return prevState - 1;
        }
        return prevState;
      });
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const onSentOtp = async () => {
    setLoading(true);
    const result = await postSentOTP(formValues?.email);
    if (result.status === 200) {
      setAlert({
        type: "success",
        text: T("Verification Code Sent!"),
      });
      setSentOtp(180);
    } else {
      setAlert({
        type: "error",
        text: result?.data?.error?.message,
      });
    }
    setLoading(false);
  };

  const onFacebook = async () => {
    setLoading(true);
    const result = await postFacebookAuth();
    if (result?.accessToken) {
      const result2 = await postFacebookAuth2(result?.accessToken);
      setLoading(false);
      if (result2.status === 200) {
        const token = result2?.data?.data?.token;
        if (token) {
          const { isVerify, email } = await checkIsVerifySocial(token);
          if (isVerify) {
            setUser({
              token: token,
            });
          } else {
            setModalVerifyEmail({
              token,
              email,
            });
          }
        } else {
          onAcceptCreate2("facebook", result?.accessToken);
        }
      } else {
        setAlert({
          type: "error",
          text: result2?.data?.error?.message,
        });
      }
    } else {
      setLoading(false);
    }
  };
  const onApple = async () => {
    setLoading(true);
    const result = await postAppleAuth();
    if (result?.authorization?.id_token) {
      const result2 = await postAppleAuth2(result?.authorization?.id_token);
      setLoading(false);
      if (result2.status === 200) {
        const token = result2?.data?.data?.token;
        if (token) {
          const { isVerify, email } = await checkIsVerifySocial(token);
          if (isVerify) {
            setUser({
              token: token,
            });
          } else {
            setModalVerifyEmail({
              token,
              email,
            });
          }
        } else {
          onAcceptCreate2("apple", result?.authorization?.id_token);
        }
      } else {
        setAlert({
          type: "error",
          text: result2?.data?.error?.message,
        });
      }
    } else {
      setLoading(false);
    }
  };

  const checkIsVerifySocial = async (token) => {
    return await getProfile({
      headers: { Authorization: `Bearer ${token}` },
    }).then((res) => ({
      isVerify: !!res?.data?.data?.verify_social_email_status,
      email: res?.data?.data?.email,
    }));
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async ({ access_token }) => {
      setLoading(true);
      const result2 = await postGoogleAuth2(access_token);
      setLoading(false);
      if (result2.status === 200) {
        const token = result2?.data?.data?.token;
        if (token) {
          const { isVerify, email } = await checkIsVerifySocial(token);
          if (isVerify) {
            setUser({
              token: token,
            });
          } else {
            setModalVerifyEmail({
              token,
              email,
            });
          }
        } else {
          onAcceptCreate2("google", access_token);
        }
      } else {
        setAlert({
          type: "error",
          text: result2?.data?.error?.message,
        });
      }
    },
    onNonOAuthError: () => {
      setLoading(false);
    },
    onError: async () => {
      setLoading(false);
    },
  });

  const onGoogle = async () => {
    setLoading(true);
    googleLogin();
  };

  const onInstagram = async () => {
    localStorage.setItem("isLoginIstagram", "true");
    setLoading(true);
    onInsta();
  };

  const onCloseModal = () => {
    setModalVerifyEmail({});
  };

  const onInsta = useLoginInstagram({
    implicitAuth: true,
    clientId: environment.INSTAGRAM_APP_ID,
    redirect_uri: environment.INSTAGRAM_REDIRECT_URI,
    onSuccess: async (code) => {
      localStorage.removeItem("isLoginIstagram");
      const result2 = await postInstagramAuth2(
        code,
        environment.INSTAGRAM_REDIRECT_URI
      );
      setLoading(false);
      if (result2.status === 200) {
        console.log("login", result2);
        const token = result2?.data?.data?.token;
        const accessToken = result2?.data?.data?.accessToken;
        if (token) {
          const { isVerify, email } = await checkIsVerifySocial(token);
          if (isVerify) {
            setUser({
              token: token,
            });
          } else {
            setModalVerifyEmail({
              token,
              email,
            });
          }
        } else {
          onAcceptCreate2("instagram", accessToken);
        }
      } else {
        setAlert({
          type: "error",
          text: result2?.data?.error?.message,
        });
      }
      setLoading(false);
    },
    onFailure: (err) => {
      localStorage.removeItem("isLoginIstagram");
      setLoading(false);
    },
  });

  const onAcceptCreate2 = async (mode, token) => {
    let result;
    setLoading(true);
    if (mode === "apple") {
      result = await postAppleAuth3(token);
    } else if (mode === "facebook") {
      result = await postFacebookAuth3(token);
    } else if (mode === "google") {
      result = await postGoogleAuth3(token);
    } else if (mode === "instagram") {
      result = await postInstagramAuth3(token);
    }
    console.log("register", result);
    setLoading(false);
    if (result.status === 200) {
      const token = result?.data?.data?.token;
      if (token) {
        const { isVerify, email } = await checkIsVerifySocial(token);
        if (isVerify) {
          setUser({
            token: token,
          });
        } else {
          setModalVerifyEmail({
            token,
            email,
          });
        }
      } else {
        setAlert({
          type: "error",
          text: result?.data?.error?.message,
        });
      }
    } else {
      setAlert({
        type: "error",
        text: result?.data?.error?.message,
      });
    }
  };

  let params = new URLSearchParams(window.location.search);
  const redirect_url = params.get("redirect_uri");
  if (redirect_url) {
    setCookie("redirect_uri", redirect_url);
  }
  const loginUrl = ssoLoginUrl();
  window.location.href = loginUrl;
  return null;
}

export default Auth;
